import type { ClientMenuItem } from '@dealerportal/common';
import Link from 'next/link';
import { useContext } from 'react';
import { NavigationContext } from './Navigation';

type Props = {
  menu: ClientMenuItem;
  className?: string | undefined;
  /** Extra classes for the `<li>`, which callers cannot wrap in another `<li>`. */
  extraItemClassName?: string | undefined;
  depthLevel: number;
};

export const NavMobileMenuItemLink = (props: Props) => {
  const { menu, className, extraItemClassName, depthLevel } = props;
  const navClassNames = useContext(NavigationContext);
  const itemClassName =
    depthLevel === 0
      ? `nav__item ${navClassNames.itemclass}`
      : depthLevel === 1
        ? `nav__child-item ${navClassNames.childitemclass}`
        : depthLevel === 2
          ? `nav__grandchild-item ${navClassNames.grandchilditemclass}`
          : `nav__greatgrandchild-item ${navClassNames.greatgrandchilditemclass}`;
  const linkClassName =
    depthLevel === 0
      ? `nav__link ${navClassNames.linkclass}`
      : depthLevel === 1
        ? `nav__child-link ${navClassNames.childlinkclass}`
        : depthLevel === 2
          ? `nav__grandchild-link ${navClassNames.grandchildlinkclass}`
          : `nav__greatgrandchild-link ${navClassNames.greatgrandchildlinkclass}`;

  return (
    <li
      className={`${itemClassName} ui-m-0 --no-children${extraItemClassName ? ` ${extraItemClassName}` : ''}`}
    >
      {menu.alias && menu.alias?.length > 0 ? (
        <Link
          prefetch={false}
          className={`${linkClassName} ui-block ui-p-4 ui-text-left ui-no-underline !ui-text-base ${className}`}
          style={{
            color: 'inherit',
            fontFamily: 'inherit',
            fontWeight: 'inherit',
          }}
          href={menu.alias}
          target={menu.target}
        >
          {menu.name}
        </Link>
      ) : (
        <div
          className={`${linkClassName} ui-block ui-p-4 ui-text-left ui-no-underline !ui-text-base ${className}`}
          style={{
            color: 'inherit',
            fontFamily: 'inherit',
            fontWeight: 'inherit',
          }}
        >
          {menu.name}
        </div>
      )}
    </li>
  );
};
